import React from "react";
import { Link } from "react-router-dom";
import "tachyons";
import "./404.css";

const Err = () => {
    return (
        <div className="err">
            <section className="vh-100 bg-animated baskerville">
                <header className="tc lh-copy">
                    <h1 className="f1 f-headline-l code mb3 fw9 dib tracked-tight light-purple">
                        404
          </h1>
                    <h2 className="tc f1-l fw1">
                        Sorry, we can't find the page you are looking for.
          </h2>
                </header>
                <p className="fw1 i tc mt4 mt5-l f4 f3-l">
                    Are you looking for one of these?
        </p>
                <ul className="list tc pl0 w-100 mt5">
                    <li className="dib">
                        <Link
                            className="f5 f4-ns link black db pv2 ph3 hover-light-purple"
                            exact to="/"
                        >
                            Home
            </Link>
                    </li>
                    <li className="dib">
                        <Link
                            className="f5 f4-ns link black db pv2 ph3 hover-light-purple"
                            exact to="/help"
                        >
                            Portfolio
            </Link>
                    </li>
                    <li className="dib">
                        <Link
                            className="f5 f4-ns link black db pv2 ph3 hover-light-purple" exact to="/service"
                        >
                            Service
            </Link>
                    </li>
                    <li className="dib">
                        <Link
                            className="f5 f4-ns link black db pv2 ph3 hover-light-purple"
                            exact to="/about"
                        >
                            About
            </Link>
                    </li>
                    <li className="dib">
                        <Link
                            className="f5 f4-ns link black db pv2 ph3 hover-light-purple"
                            exact to="/contact"
                        >
                            Contact
            </Link>
                    </li>
                    <li className="dib">
                        <Link
                            className="f5 f4-ns link black db pv2 ph3 hover-light-purple"
                            exact to="/signup"
                        >
                            Sign Up
            </Link>
                    </li>
                </ul>
            </section>
        </div>
    );
};

export default Err;
